import UpdateProject from "../components/setting/projectSettings/UpdateProject";

const UpdateProjectPage = () =>{
     return(
        <UpdateProject/>
     )
}

export default UpdateProjectPage